import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import GenericModal from "../../../Ui/Modal";
import ButtonComponent from "../../../Ui/Button";
import FormField from "../../../utils/FormFileds";
import RescheduleTimeSlotPicker from "../../Reschedule/RescheduleTimeSlotPicker";

const ScheduleWarrantySchema = Yup.object().shape({
  rescheduleReason: Yup.string()
    .trim()
    .required("A warranty scheduling note is required"),
  days_available: Yup.array()
    .of(Yup.string())
    .min(1, "Select at least one available time slot"),
});

const WarrantyScheduleRepairModal = ({
  open,
  onClose,
  onSubmit,
  submitting = false,
  title = "Schedule Warranty Repair",
  submitLabel = "Submit to Customer",
}) => {
  const formikSubmitRef = React.useRef(null);

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="982px"
      children={
        <Formik
          key={open ? "warranty-schedule-open" : "warranty-schedule-closed"}
          initialValues={{
            rescheduleReason: "",
            available_from: "",
            available_to: "",
            days_available: [],
          }}
          validationSchema={ScheduleWarrantySchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, submitForm }) => {
            formikSubmitRef.current = submitForm;
            return (
              <div className="md:px-0 px-2">
                <Form
                  onSubmit={handleSubmit}
                  className="rounded-[16px] border border-[#ECECEC] flex flex-col my-4 gap-8 max-w-[720px] w-full md:mx-auto md:py-6 py-2 md:px-[32px] px-2"
                >
                  <h1 className="md:text-[32px] text-[20px] text-[#242424] text-center font-medium">
                    {title}
                  </h1>
                  <p className="md:text-[20px] text-[16px] text-[#242424] font-medium text-center">
                    Propose all time slots you&apos;re available so the customer can confirm the return visit.
                  </p>
                  <FormField
                    type="textarea"
                    name="rescheduleReason"
                    label="Add notes for the warranty return visit:"
                    placeholder="Enter here"
                    rows={4}
                  />
                  <RescheduleTimeSlotPicker />
                </Form>
              </div>
            );
          }}
        </Formik>
      }
      footer={
        <div className="flex w-full justify-between mt-6">
          <ButtonComponent paddingY="10px" onClick={onClose}>
            Back
          </ButtonComponent>
          <ButtonComponent
            bgColor="#3CAB5C"
            color="#FFFFFF"
            paddingY="10px"
            disabled={submitting}
            onClick={() => formikSubmitRef.current && formikSubmitRef.current()}
          >
            {submitting ? "Submitting..." : submitLabel}
          </ButtonComponent>
        </div>
      }
    />
  );
};

export default WarrantyScheduleRepairModal;
